import { Link } from '@remix-run/react'
import { AuthorAvatar } from '../AuthorAvatar'
import type { AuthorSizes } from '../AuthorAvatar'
import { generatePath } from 'react-router'
import { routes } from '~/queries/routes'
import { Asset } from 'contentful'

export type AuthorFields = {
  name: string
  slug: string
  avatar?: Asset<'WITHOUT_UNRESOLVABLE_LINKS', string> | undefined
  title?: string | undefined
  bio?: string | undefined
  twitter?: string | undefined
  facebook?: string | undefined
  linkedin?: string | undefined
}

export type AuthorLabelProps = {
  fields: AuthorFields
  size?: AuthorSizes
  withTitle?: boolean
}

export const AuthorLabel = ({ fields, size, withTitle }: AuthorLabelProps) => {
  const { name, avatar, title, slug } = fields
  return (
    <div className="flex items-center">
      {avatar && <AuthorAvatar asset={avatar} size={size} />}
      <div>
        <Link
          className="text-s before:absolute before:content-none"
          to={generatePath(routes.author, { slug })}
        >
          {name}
        </Link>
        {withTitle && title && <p className="text-s text-neutral-60">{title}</p>}
      </div>
    </div>
  )
}
